import { render } from "./match-builder.pug?vue&type=template&id=c77ad36c&ts=true&lang=pug&external"
import script from "./match-builder.ts?vue&type=script&lang=ts&external"
export * from "./match-builder.ts?vue&type=script&lang=ts&external"

import "./match-builder.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__